import { useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useState } from 'react';
import LinearProgressBar from 'src/components/progress-bar/progressBar.component';
import { CommonHelper } from 'src/utils/commonHelper';
import { useToaster } from 'src/utils/toaster/toasterContext';
import { PostUtil } from '../new-post-new/post-util';
import UploadImage from '../new-post-new/uploadFile';
import { useTranslation } from 'react-i18next';

const MediaUploadComponent = ({ handleMediaFiles, isUploadToImageServer = false }) => {
  const { t: translate } = useTranslation();
  const [fileUploadprogress, setFileUploadprogress] = useState(0);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const maxFileSizeInBytes = 6 * 1073741824; // 6 GB (6 * 1024 * 1024 * 1024)
  const { showToast } = useToaster();

  const fileUploadSuccessCallback = (data, message) => {
    message && showToast(message, 's');
    let mediaData = [];
    if (isUploadToImageServer) {
      mediaData = data;
    } else {
      mediaData = data?.media_data;
    }
    if (mediaData && mediaData.length > 0) {
      let uploadedFiles = mediaData.map((uploadedData) => {
        return {
          media_url: uploadedData.media_url,
          thumbnail_urls: uploadedData.thumbnail_urls,
          aspect_ratio: uploadedData.aspect_ratio,
          video_length: uploadedData.video_length,
          media_type: uploadedData.media_type,
          file_size: uploadedData.file_size,
        };
      });
      handleMediaFiles([...uploadedFiles]);
    } else {
      showToast(translate('common.something_went_wrong'), 'e');
    }
  };
  const failureCallback = (message) => {
    message && showToast(message, 'e');
  };
  const handleImages = (files) => {
    const unsupportedExtensions = ['jfif'];
    let supportedFiles = files.filter((a) => {
      const extension = CommonHelper.GetFileExtension(a.name);
      return PostUtil.SupportedFileFormat.includes(a.type) && !unsupportedExtensions.includes(extension);
    });
    if (supportedFiles.length === files.length || supportedFiles.length > 0) {
      if (!files.some((a) => a.size > maxFileSizeInBytes)) {
        if (isUploadToImageServer) {
          let uploadFilesProps = {
            files,
            setFileUploadprogress,
            successCallback: fileUploadSuccessCallback,
            failureCallback,
          };
          CommonHelper.UploadMediaFilesToServer({ ...uploadFilesProps });
        } else {
          handleMediaFiles(files);
        }
      } else {
        showToast(
          `${translate('media_library.max_file_size')} 6GB ${translate('media_library.select_below_max_size')} 6GB`,
          'e'
        );
      }
    } else {
      let errorMessage = `${translate('common.we_only_support')} JPEG, JPG, PNG & MP4 ${translate(
        'common.file_formats'
      )}`;
      if (files.length > 1) {
        errorMessage = errorMessage + translate('media_library.one_of_the_file_is_not_in_the_format');
      } else {
        errorMessage =
          errorMessage +
          `${translate('common.we_only_support')} JPEG, JPG, PNG & MP4 ${translate('common.file_formats')}`;
      }
      showToast(errorMessage, 'e');
    }
  };
  return (
    <>
      <UploadImage name="images" accept={['image/*', 'video/*']} onDrop={handleImages} isMobile={isMobile} />
      {fileUploadprogress > 0 && <LinearProgressBar value={fileUploadprogress} />}
    </>
  );
};
export default MediaUploadComponent;
